import React from 'react'

import { Row, IconContainer, TimeCount, StopNames, MobileIcon } from './Styles'
import { ReactComponent as HalfMoon } from 'assets/images/HalfMoon.svg'
import { ReactComponent as ArrowRight } from 'assets/images/XSArrowRight.svg'
import { GrouppedRoute } from 'utils/types'
import { getStops, getFormattedMinutesHours } from 'utils/utils'
import RouteTicket from './RouteTicket'

const TICKETS_TOOLTIP_CONTENT = 'Multiple tickets are required for this journey'

interface Props {
  route: GrouppedRoute
  selected: boolean
  hovered: boolean
  handleClickItem?: (id: string) => void
  handleEnterItem?: (id: string) => void
  handleLeaveItem?: () => void
}

const RouteItem = ({
  route,
  selected,
  hovered,
  handleClickItem,
  handleEnterItem,
  handleLeaveItem,
}: Props) => {
  const isDirect = route.path.length <= 2
  const stopNames = isDirect ? 'Direct flight' : getStops(route.path)
  const timeToShow = getFormattedMinutesHours(route.groupMinMaxTime[0])

  return (
    <Row
      selected={selected}
      hovered={hovered}
      onClick={() => handleClickItem?.(route.id)}
      onMouseEnter={() => handleEnterItem?.(route.id)}
      onMouseLeave={handleLeaveItem}
    >
      <StopNames>{stopNames}</StopNames>
      {route.n_tickets > 1 ? (
        <RouteTicket n_tickets={route.n_tickets} content={TICKETS_TOOLTIP_CONTENT} />
      ) : null}
      {route.overnight && (
        <IconContainer style={{ marginLeft: '.8rem' }}>
          <HalfMoon />
        </IconContainer>
      )}
      <TimeCount>{timeToShow}</TimeCount>
      <MobileIcon>
        <ArrowRight />
      </MobileIcon>
    </Row>
  )
}

export default React.memo(RouteItem)
